const state = {
	WxList: [], //登录的微信列表
	chatMsg:"",  //聊天的消息
	msgUserInfo:"",  //聊天会员列表的用户
	selectUserTab:0,  //选择聊天的顶部分类 0服务中 1暂停中 2已毕业
	
	isLoading:false,    //是否在加载中（正在请求查询聊天记录
	isScreenMode:false,  //是否为筛选模式	
	isNotification:true,  //是否开启消息声音提醒
	replaceClockInMode:false, //代打卡模式
	drawToTalkMode:false, //将聊天记录提取为话术模式，黄耿智：2022-10-15
	chatInputDraftList:[],   //聊天草稿列表  {id:'',msg:''}
	
	
	standVipList:[],      //待接待的准会员列表
	
	isShowChatTableAdminName:false,//是否在聊天界面显示教练名称，黄耿智：2022-12-16
	
	isOpenTypingAssociation:false,//是否开启打字联想辅助，黄耿智：2023-01-11
	
	// webSocket状态相关数据
	// 黄耿智：2022-12-16
	webSocketStatus:{
		//webSocket聊天
		"0":{
			status:0,//状态，0=已关闭，1=已连接，2=连接中，3=已关闭，4=发生错误
		},
		//webSocket通用
		"1":{
			status:0,//状态，同上
		}
	},
	
	//是否手动设置“已下线”，设置后不再重连webSocket
	// 黄耿智：2022-12-21
	isManualSetOffline:false,
	
	// 是否播放过登录背景音（一般首次登录时播放一次，再刷新不重复播放）
	// 黄耿智：2023-03-09
	hasPlayedLoginMusic:false,
	
}

const mutations = {
	
	setChatMsg(state, chatMsg){
		state.chatMsg = chatMsg || "";
	},
	setWxList(state, WxList) {
		state.WxList.push(WxList)
		state.WxList = state.WxList.filter(f=>{
			let newData = Object.assign({},f)
			return newData.hasOwnProperty('wxid')
		})
		//去重
		let newArry = [];
		 for(let item of state.WxList){
			let index = newArry.findIndex(f=>{
				 return f.wxid == item.wxid
			 })
			 if(index==-1){
				newArry.push(item)
			 }
		 }
		 console.log(newArry,"newArry")
		state.WxList =  newArry
	},
	clearWxList(state){
		state.WxList = []
	},
	setMsgUserInfo(state, msgUserInfo){
		state.msgUserInfo = msgUserInfo;
	},
	setReplaceClockInMode(state,replaceClockInMode){
		state.replaceClockInMode = replaceClockInMode;
	},
	// 从聊天记录中提取成为话术，黄耿智：2022-10-15
	setDrawToTalkMode(state,drawToTalkMode){
		state.drawToTalkMode = drawToTalkMode;
	},
	setIsScreenMode(state,isScreenMode){
		state.isScreenMode = isScreenMode
	},
	setIsLoading(state,isLoading){
		state.isLoading = isLoading
	},
	setIsNotification(state,isNotification){
		state.isNotification = isNotification
	},
	// 是否在聊天界面显示教练名称
	// 黄耿智：2022-12-16
	setIsShowChatTableAdminName(state,isShowChatTableAdminName){
		state.isShowChatTableAdminName = isShowChatTableAdminName
	},
	// 是否开启聊天打字联想辅助
	// 黄耿智：2023-01-11
	setIsOpenTypingAssociation(state,isOpenTypingAssociation){
		state.isOpenTypingAssociation = isOpenTypingAssociation
	},
	
	setChatInputDraft(state,draftData){
		let tempMsg = draftData.msg.replace('/n', '')
		tempMsg = tempMsg.trim()
		let findIndex = state.chatInputDraftList.findIndex((item,index)=>{
			return item.id == draftData.id
		})
		if(findIndex == -1){
			if(tempMsg != ''){
				state.chatInputDraftList.push(draftData)
			}
		}else{
			if(tempMsg != ''){
				state.chatInputDraftList[findIndex].msg = draftData.msg
			}else{
				state.chatInputDraftList.splice(findIndex,1)
			}
		}
	},
	setStandVipList(state,standVipList){
		state.standVipList = standVipList
	},
	setSelectUserTab(state,selectUserTab){
		state.selectUserTab = selectUserTab
	},
	// 设置webSocket状态（一般是连接上或断开时调用）
	// 黄耿智：2022-12-16
	setWebSocketStatus(state,statusData){
		console.log("chat.js webSocketStatus 数据参数",statusData);
		if(statusData){
			state.webSocketStatus[statusData.wsType+""] = statusData.status;
		}
		else{
			console.log("chat.js webSocketStatus 数据参数不正确 ",statusData);
		}
	},
	//是否手动设置“已下线”，设置后不再重连webSocket
	// 黄耿智：2022-12-21
	setIsManualSetOffline(state,data){
		state.isManualSetOffline = data
	},
	// 是否播放过登录背景音（一般首次登录时播放一次，再刷新不重复播放）
	// 黄耿智：2023-03-09
	setHasPlayedLoginMusic(state,data){
		state.hasPlayedLoginMusic = data
	},
}

const actions = {
	setChatMsg({commit},data) {
		// do something async
		commit('setChatMsg',data)
	},
	setWxList({commit},data) {
		// do something async
		commit('setWxList',data)
	},
	clearWxList({commit},data) {
		// do something async
		commit('clearWxList',data)
	},
	setMsgUserInfo({commit},data) {
		// do something async
		setTimeout(() => {
			commit('setMsgUserInfo',data)
		},500)
	},
	setReplaceClockInMode({commit},data){
		commit('setReplaceClockInMode',data)
	},
	// 从聊天记录中提取成为话术，黄耿智：2022-10-15
	setDrawToTalkMode({commit},data){
		commit('setDrawToTalkMode',data)
	}
}

const getters = {
	getChatInputDraft(state){
		return draftId =>{
			let findIndex = state.chatInputDraftList.findIndex((item,index)=>{
				return item.id == draftId
			})
			return state.chatInputDraftList[findIndex].msg
			// if(findIndex == -1){
			// 	return '空白'
			// }else{
			// 	return state.chatInputDraftList[findIndex].msg
			// }
		}
		
	}
}

export default {
	state,
	mutations,
	actions,
	getters
}



// WEBPACK FOOTER //
// ./src/store/modules/chat.js